import { CompilationContext, CompilationResult } from '../compilation';
import { applyStyles } from '../rendering-properties';
import { Content, ContentParametersInfo } from './';

export interface FbContentParams {
  showReactions: boolean;
  showComments: boolean;
  showShares: boolean;
  emojiCount: number;
}

export const FACEBOOK_PARAMETERS_INFO: ContentParametersInfo<FbContentParams> = {
  showReactions: {
    valueType: 'boolean',
    required: true
  },
  showComments: {
    valueType: 'boolean',
    required: true
  },
  showShares: {
    valueType: 'boolean',
    required: true
  },
  emojiCount: {
    valueType: 'number',
    required: true,
    // Ce paramètre ne peut être utilisé pour le moment, car Mustache est trop basique pour gérer ça
    hiddenInSidebar: true,
    minValue: 1,
    maxValue: 6
  }
};

export const DEFAULT_FB_PARAMETERS: Content<FbContentParams>['params'] = {
  static: {
    showReactions: true,
    showComments: true,
    showShares: true,
    emojiCount: 3
  },
  dynamic: {
    showReactions: true,
    showComments: true,
    showShares: true,
    emojiCount: 3
  }
};

export type FbContent = Content<FbContentParams>;

export const compileToHtmlNodes = (content: FbContent, articleIndex: number, spaceBetweenParagraphs: number, context: CompilationContext): CompilationResult => {

  const result: CompilationResult = {
    nodes: [],
    context
  };

  if (!content.articleRef) {
    // Ce type de bloc ne fonctionne que s'il est associé à un article.
    return result;
  }

  const startingWrapper: Text = document.createTextNode(`{{ #reco_${articleIndex} }}`);
  const endingWrapper: Text = document.createTextNode(`{{ /reco_${articleIndex} }}`);
  const createLink = (innerText: string): HTMLAnchorElement => {
    const link = document.createElement('a');
    link.href = '{{ metadata.mediegoLink }}';
    link.rel = 'noopener noreferrer';
    link.target = '_blank';
    link.innerText = innerText;
    return link;
  }
  const createEmoji = (reaction: string): HTMLImageElement => {
    const emoji = document.createElement('img');
    emoji.src = `https://api.mediego.com/assets/social/fb_${reaction}.png`;
    emoji.alt = `Facebook réaction ${reaction}`;
    emoji.width = 16;
    emoji.height = 16;
    emoji.style.verticalAlign = 'sub';
    return emoji;
  }
  const params = content.params.dynamic;
  const table_tag = document.createElement('table');
  table_tag.role = 'presentation';
  applyStyles(table_tag, content.innerRenderingProperties);
  table_tag.style.width = '100%';
  table_tag.classList.add('ql');
  const tr_tag = document.createElement('tr');
  table_tag.appendChild(tr_tag);
  const td_tag_reactions = document.createElement('td');
  td_tag_reactions.style.textAlign = 'left';
  const link_reactions = createLink('{{ #enhancements }}{{ total }}{{ /enhancements }} réactions');
  ['like', 'wow', 'love'].forEach(reaction => td_tag_reactions.appendChild(createEmoji(reaction)));
  // On ajoute un espace insécable
  td_tag_reactions.appendChild(document.createTextNode('\u00A0'));
  td_tag_reactions.appendChild(link_reactions);
  tr_tag.appendChild(td_tag_reactions);
  if (params.showComments || params.showShares) {
    const td_tag_comments_shares = document.createElement('td');
    td_tag_comments_shares.style.textAlign = 'right';
    let content = '';
    if (params.showComments) {
      content += '{{ #enhancements }}{{ comments }}{{ /enhancements }} commentaires';
    }
    if (params.showComments && params.showShares) {
      content += ' - ';
    }
    if (params.showShares) {
      content += '{{ #enhancements }}{{ shares }}{{ /enhancements }} partages';
    }
    const link_comments_shares = createLink(content);
    td_tag_comments_shares.appendChild(link_comments_shares);
    tr_tag.appendChild(td_tag_comments_shares);
  }
  result.nodes = [startingWrapper, table_tag, endingWrapper];
  return result;
};
